import { Link } from "react-router-dom";
import { UserPlus } from "lucide-react";
import { PageHeader } from "../../components/admin/PageHeader";
import { ProfileListPanel } from "../../components/admin/ProfileListPanel";
import { BULK } from "../../components/admin/bulkActions";
import { useAuth } from "../../context/AuthContext";
import { canDo } from "../../lib/adminApi";

const TITLES = { bride: "Brides", groom: "Grooms" };

export default function UserManagement({ profileFor }) {
  const auth = useAuth();
  const actions = [BULK.approve, BULK.reject, BULK.block, BULK.delete].filter((a) => canDo(auth, a.perm));
  const title = TITLES[profileFor] || "All Profiles";
  return (
    <div data-testid="user-management-page" data-group={profileFor || "all"}>
      <PageHeader eyebrow="User Management" title={title}>
        {canDo(auth, "can_edit") && (
          <Link to="/admin/profiles/new" data-testid="add-profile-button" className="inline-flex items-center gap-2 rounded-full bg-[#7A0016] px-4 py-2 text-sm font-semibold text-[#F5E6BA] hover:bg-[#4A000E]">
            <UserPlus className="h-4 w-4" /> Add New Profile
          </Link>
        )}
      </PageHeader>
      <ProfileListPanel
        key={profileFor || "all"}
        base={profileFor ? { profile_for: profileFor } : {}}
        statusTabs
        bulkActions={actions}
        exportName={title.toLowerCase().replace(/\s+/g, "-")}
        exportTitle={`Real Match Matrimony - ${title}`}
      />
    </div>
  );
}
